<template>
  <table class="c-table">
    <thead>
      <tr>
        <th>サイト名</th>
        <th width="170">お名前</th>
        <th>メールアドレス</th>
        <th width="170"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="isLoading">
        <td colspan="4" class="l-p-0 c-text--center">
          <LoadingChara variant="inline">
            <template slot="title">
              データ取得中
            </template>
          </LoadingChara>
        </td>
      </tr>
      <tr v-else-if="!hasProject">
        <td colspan="4" class="l-p-0">
          <Error img="normal" variant="inline">
            <template slot="title">
              サイト単位でのアクセス権を持つユーザーがいません。
            </template>
            <p>
              アカウント管理ユーザーは、全サイトのアクセス権を持っているため表示されません。
            </p>
          </Error>
        </td>
      </tr>
      <template v-else>
        <template v-for="item in items">
          <ListItemAccessUser
            v-for="(user, index) in item.users"
            :key="item.projectId + '_' + user.userId"
            :index="index"
            :item="{
              ...user,
              projectId: item.projectId,
              projectName: item.projectName
            }"
            :rowspan="item.users.length"
            @delete="deleteUser"
          />
        </template>
      </template>
    </tbody>
  </table>
</template>

<script>
import Error from '@/components/Error';
import ListItemAccessUser from '@/components/config/ListItemAccessUser';
import LoadingChara from '@/components/LoadingChara';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Error,
    ListItemAccessUser,
    LoadingChara
  },
  computed: {
    hasProject() {
      return this.items.some(item => item.users.length > 0);
    }
  },
  methods: {
    deleteUser(item) {
      this.$emit('delete', item);
    }
  }
};
</script>
